/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var SignatureDocumentType;

(function (SignatureDocumentType) {
  SignatureDocumentType["ADMITTED_MPL_APPLICATION"] = "admitted_mpl_application";
  SignatureDocumentType["ADMITTED_MPL_AOP_ADDENDUM"] = "admitted_mpl_aop_addendum";
  SignatureDocumentType["GA_BI_STATE_ACKNOWLEDGMENT"] = "ga_bi_state_acknowledgment";
  SignatureDocumentType["CLAIM_SUPPLEMENT"] = "claim_supplement";
  SignatureDocumentType["PURCHASE_OR_MERGER_SUPPLEMENT"] = "purchase_or_merger_supplement";
  SignatureDocumentType["NO_CLAIM_REPORT"] = "no_claim_report";
})(SignatureDocumentType || (SignatureDocumentType = {}));